import type { Questionnaire } from "../schemas/questionnaireSchemas";

interface Props {
  questionnaire: Pick<Questionnaire, "questions">;
  values?: Record<string, string | number>;
  onChange?: (key: string, value: string | number) => void;
  readOnly?: boolean;
}

export function FixedQuestionnaireForm({ questionnaire, values = {}, onChange, readOnly = false }: Props) {
  return (
    <>
      {questionnaire.questions.map((question) => (
        <fieldset className="card shadow mb-4" key={question.key} disabled={readOnly}>
          <div className="card-body">
            <legend className="h6">
              {question.position}. {question.prompt}
              {question.required && (
                <span className="text-danger" aria-label="必填">
                  {" "}*
                </span>
              )}
            </legend>
            {question.type === "TEXT" && (
              <textarea
                className="form-control"
                maxLength={question.maxLength ?? undefined}
                value={String(values[question.key] ?? "")}
                onChange={(event) => onChange?.(question.key, event.target.value)}
                required={question.required}
              />
            )}
            {question.type === "SINGLE_CHOICE" &&
              question.options.map((option) => (
                <label className="d-block mb-2" key={option.value}>
                  <input
                    type="radio"
                    name={question.key}
                    value={option.value}
                    checked={values[question.key] === option.value}
                    onChange={() => onChange?.(question.key, option.value)}
                    required={question.required}
                  />{" "}
                  <span>{option.label}</span>
                </label>
              ))}
            {question.type === "RATING_SCALE" && (
              <div role="radiogroup" aria-label={question.prompt} className="d-flex flex-wrap align-items-center gap-3">
                <span>{question.scaleMinLabel}</span>
                {Array.from({ length: (question.scaleMax ?? 0) - (question.scaleMin ?? 0) + 1 }, (_, index) => (question.scaleMin ?? 1) + index).map((rating) => (
                  <label key={rating} className="text-center mx-2">
                    <span className="d-block">{rating}</span>
                    <input
                      type="radio"
                      name={question.key}
                      value={rating}
                      checked={values[question.key] === rating}
                      onChange={() => onChange?.(question.key, rating)}
                      required={question.required}
                    />
                  </label>
                ))}
                <span>{question.scaleMaxLabel}</span>
              </div>
            )}
            {question.type === "SINGLE_CHOICE" && question.allowOther && values[question.key] === "OTHER" && (
              <label className="mt-2 d-block">
                其他說明
                <input
                  className="form-control"
                  value={String(values[`${question.key}:other`] ?? "")}
                  onChange={(event) => onChange?.(`${question.key}:other`, event.target.value)}
                  required
                />
              </label>
            )}
          </div>
        </fieldset>
      ))}
    </>
  );
}
